import BackendClient from '../backend-client';
import Survey, { modelFactory } from './model';

export default class SurveyClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
  }

  survey = async (rating, comment) => {
    const response = await this.request('post')({ rating, comment });
    return this.format(response);
  }
}

export {
  Survey,
};
